const AUTH_KEY =
  "client_auth";

export function setAuth(
  auth
) {

  localStorage.setItem(
    AUTH_KEY,
    JSON.stringify(auth)
  );

}

export function getAuth() {

  try {

    const raw =
      localStorage.getItem(
        AUTH_KEY
      );

    if (!raw) {

      return null;

    }

    return JSON.parse(
      raw
    );

  } catch {

    return null;

  }

}

export function clearAuth() {

  localStorage.removeItem(
    AUTH_KEY
  );

}

export function isLoggedIn() {

  const auth =
    getAuth();

  return !!auth?.accessToken;

}